import React from "react";
import "./localizacao-style.css";
import ImgSobre from '../../img/Local.png';
import iconeExpo from '../../img/icons/EvenIcon.svg';
import iconeAeroporto from '../../img/icons/AirPortIcon.svg';
import iconeMetro from '../../img/icons/SubwayIcon.svg';
import iconeWaypoint from '../../img/icons/WayPointIcon.svg';




export default function SobreNos() {
  const servicos = [
    { icon:iconeExpo, label: "06 Minutos de São Paulo Expo" },
    { icon: iconeAeroporto, label: "18 Minutos do Aeroporto de Conhonhas" },
    { icon: iconeMetro, label: "05 Minutos do Metrô Jabaquara" },
    { icon: iconeWaypoint, label: "Avenida Engenheiro  Armando de Arruda Pereira, 2937 Jabaquara, São Paulo/SP-  bloco C 410" },
  ];

  return (
    <section id="sobre" className="sobre-nos">
      <div className="sobre-nos__container">
        {/* LADO ESQUERDO */}
        <div className="sobre-nos__left">
            <a  href="https://www.google.com/maps?gs_lcrp=EgZjaHJvbWUqDggBEEUYJxg7GIAEGIoFMgYIABBFGDwyDggBEEUYJxg7GIAEGIoFMgwIAhBFGDkYsQMYgAQyDAgDECMYJxiABBiKBTIGCAQQRRg7Mg8IBRAAGBQYhwIYsQMYgAQyBggGEEUYPDIGCAcQRRg80gEINDEwM2owajSoAgCwAgE&um=1&ie=UTF-8&fb=1&gl=br&sa=X&geocode=KUVfj83bWs6UMXn5jReHfMx7&daddr=Av.+Eng.+Armando+de+Arruda+Pereira,+2937+-+C410+-+Jabaquara,+São+Paulo+-+SP,+04309-010"
                target="_blank"
                rel="noopener noreferrer">
              <img src={ImgSobre} alt="Espaço do coworking" className="sobre-nos__imagem" />
            </a>
          </div>

        {/* LADO DIREITO */}
        <div className="sobre-nos__right">

          <ul className="sobre-nos__lista">
            {servicos.map((item, idx) => (
              <li key={idx} className="sobre-nos__item">
                <div className="sobre-nos__icone">
                  <img src={item.icon} alt={item.label} />
                </div>
                <span>{item.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
